var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import Transition from 'react-transition-group/CSSTransition';
const defaultStyle = {
    opacity: 0
};
export const Fade = (_a) => {
    var { HtmlTag = 'div' } = _a, props = __rest(_a, ["HtmlTag"]);
    const [transition, setTransition] = React.useState(false);
    React.useEffect(() => {
        setTransition(props.in);
    }, [props.in]);
    return (React.createElement(Transition, { in: transition, timeout: props.timeout, appear: true, unmountOnExit: true, mountOnEnter: true, classNames: 'fade' }, state => {
        return (React.createElement(HtmlTag, { className: props.className, style: {
                transition: `opacity ${props.timeout}ms ease-in-out`
            } }, props.children && props.children));
    }));
};
//# sourceMappingURL=Fade.js.map